import Auth from "../../components/common/auth/Auth";

const AuthPage = () => {
  return <Auth />;
};

export default AuthPage;
